import React from "react";
import Accordion from "react-bootstrap/Accordion";
import "../../assets/css/terminos-mundial.css";

const TerminosMundialComponent: React.FC = () => {
  const accordionStyle = { border: '1px solid #ddd', borderRadius: '12px', overflow: 'hidden' };
  
  return (
    <section className="terminos-mundial-section">
      <div className="terminos-mundial-bg"></div>
      
      <div className="terminos-mundial-container">
        
        <h2 className="terminos-mundial-title">Términos y condiciones</h2>
        <p className="terminos-mundial-subtitle">
          Actividad: "Estás a un Hyundai de la Copa Mundial de la FIFA 2026™"
        </p>
        
        <div className="terminos-mundial-card">
          <p className="terminos-mundial-text">
            Al participar en la actividad, el cliente declara hacer leído, entendido y aceptado sin reserva alguna estos términos y condiciones.
          </p>
          
          <hr className="terminos-mundial-divider" />
          
          <div className="terminos-mundial-list">
            <Accordion>
              {/* ITEM 1 */}
              <Accordion.Item eventKey="0" className="mb-3" style={accordionStyle}>
                <Accordion.Header>1. OBJETIVO DE LA ACTIVIDAD</Accordion.Header>
                <Accordion.Body>
                  <p>La actividad tiene por objeto entregar a determinados clientes de Hyundai Colombia entradas individuales para asistir a un partido oficial de la Copa Mundial de la FIFA 2026™, conforme a la dinámica presencial descrita en este documento.</p>
                  <p>Esta actividad no constituye un sorteo, rifa, juego instantáneo ni selección aleatoria de beneficiarios. Tampoco es una actividad de azar o de fortuna. Se trata, en su totalidad, de una dinámica que depende de la destreza física del cliente participante.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 2 */}
              <Accordion.Item eventKey="1" className="mb-3" style={accordionStyle}>
                <Accordion.Header>2. ACEPTACIÓN DE LOS TÉRMINOS</Accordion.Header>
                <Accordion.Body>
                  <p>Al vincularse en la actividad, el cliente declara haber leído, entendido y aceptado sin reserva alguna estos términos y condiciones, así como cualquier modificación publicada por Hyundai Colombia S.A.S. (en adelante Hyundai Colombia), distribuidor autorizado de la marca Hyundai en Colombia, en sus canales oficiales. Si el cliente no está de acuerdo con estos términos, deberá abstenerse de vincularse a la actividad.</p>
                  <p>Estos términos se encuentran disponibles en la página web oficial de Hyundai Colombia para consulta permanente durante toda la vigencia de la actividad.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 3 */}
              <Accordion.Item eventKey="2" className="mb-3" style={accordionStyle}>
                <Accordion.Header>3. ¿CÓMO PARTICIPAR?</Accordion.Header>
                <Accordion.Body>
                  <p>Si compraste un vehículo Hyundai en uno de nuestros concesionarios autorizados, puedes participar en una actividad de destreza: patear un balón desde 7 metros e intentar que entre por la ventana del vehículo. Quienes lo logren en la etapa en su concesionario, pasan a la Gran Final del 22 de mayo.</p>
                  <p>El proceso es en dos etapas:</p>
                  <ul>
                    <li><strong>ETAPA 1 – En tu concesionario:</strong> Compra tu Hyundai nuevo entre el 26 de marzo y el 15 de mayo de 2026. Tu concesionario te informará la fecha y el lugar de la actividad local. Allí tendrás la oportunidad de patear un balón tipo felpa desde 7 metros e intentar que pase por la ventana del vehículo.</li>
                    <li><strong>ETAPA 2 – Gran Final:</strong> Si el balón pasa por la ventana, recibirás un pase para asistir a la Gran Final, que se realizará el sábado 22 de mayo de 2026 en cuatro ciudades: Bogotá, Medellín, Cali y Barranquilla, de 10:00 a.m. a 5:00 p.m. o hasta finalizar la actividad. En la Gran Final se repite la dinámica, y quienes superen las rondas obtendrán una entrada para un partido oficial de la Copa Mundial de la FIFA 2026™.</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 4 */}
              <Accordion.Item eventKey="3" className="mb-3" style={accordionStyle}>
                <Accordion.Header>4. CLIENTES ELEGIBLES</Accordion.Header>
                <Accordion.Body>
                  <p>Podrán vincularse a la actividad:</p>
                  <ul>
                    <li>Personas naturales mayores de 18 años, sin límite de edad máxima ni restricción de nacionalidad o residencia, siempre que cumplan las demás condiciones aquí establecidas. Para este efecto deberá presentar su cédula de ciudadanía el día de la actividad.</li>
                    <li>Personas asociadas a la compra de un vehículo Hyundai nuevo, de uso particular, con la venta registrada y confirmada al 100% en el sistema CRM de Hyundai Colombia desde el 26 de marzo de 2026 hasta antes del cierre de la actividad el 15 de mayo de 2026 a las 23:59 horas. El vehículo debe ser comprado en un concesionario de red autorizado de Colombia.</li>
                  </ul>
                  <p>El comprador del vehículo es el único facultado para designar al cliente que participará en la dinámica, quien deberá ser una de las siguientes personas:</p>
                  <ul>
                    <li>El vendedor del vehículo.</li>
                    <li>El titular de la tarjeta de propiedad.</li>
                    <li>Un familiar en primer grado de consanguinidad del comprador.</li>
                  </ul>
                  <p>Solo podrá designarse un cliente por vehículo adquirido. Una vez registrada la designación en el sistema CRM, en caso de alguna novedad con la compra, el comprador tendrá un plazo máximo de cuarenta y ocho (48) horas para solicitar una corrección administrativa, siempre que dicha solicitud se realice antes del cierre del 15 de mayo de 2026. Vencido este plazo, la designación será definitiva e inmodificable.</p>
                  <p>No son elegibles:</p>
                  <ul>
                    <li>Empleados directos o indirectos de Hyundai Colombia y sus familias en primer grado.</li>
                    <li>Clientes que adquieran vehículos de servicio público, taxis, vans comerciales, de uso empresarial o de uso público.</li>
                    <li>Clientes con órdenes de pedido canceladas o incompletas al cierre de la actividad.</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 5 */}
              <Accordion.Item eventKey="4" className="mb-3" style={accordionStyle}>
                <Accordion.Header>5. PASE DE ACCESO AL EVENTO FINAL</Accordion.Header>
                <Accordion.Body>
                  <p>Una vez el cliente supere satisfactoriamente la etapa en su concesionario (Etapa 1), recibirá un pase de acceso que lo habilita para participar en la Gran Final del 22 de mayo de 2026. Este pase podrá ser entregado en formato físico o digital según disponibilidad, y el cliente deberá presentarlo el día del evento final.</p>
                  <p>El pase contendrá:</p>
                  <ul>
                    <li>Ciudad asignada.</li>
                    <li>Fecha, hora y lugar exacto del evento final.</li>
                    <li>Instrucciones generales para el acceso y desarrollo de la actividad.</li>
                  </ul>
                  <p>El pase de acceso es intransferible para efectos del ingreso al evento. Hyundai Colombia no será responsable por el uso indebido del pase por parte de terceros no autorizados.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 6 */}
              <Accordion.Item eventKey="5" className="mb-3" style={accordionStyle}>
                <Accordion.Header>6. DESCRIPCIÓN DE LA MECÁNICA</Accordion.Header>
                <Accordion.Body>
                  <h6>Generalidades del evento</h6>
                  <p>La dinámica del evento implica la ejecución de un disparo de balón de fútbol. Hyundai Colombia no asume responsabilidad por limitaciones físicas o de movilidad del cliente que le impidan ejecutar la dinámica. En caso de que el cliente designado presente una condición física que le impida tomar parte, el comprador podrá solicitar la designación de un nuevo cliente conforme a las opciones establecidas, siempre que lo comunique por escrito antes del inicio del evento.</p>
                  <p>El evento final se realizará el sábado 22 de mayo de 2026 de manera simultánea en las cuatro ciudades: Bogotá, Medellín, Cali y Barranquilla. El evento iniciará a las 10:00 a.m. y finalizará a las 5:00 p.m. hora local, o hasta que se complete la actividad en cada sede. La dinámica se ejecutará bajo las mismas condiciones, elementos, reglamento y criterios de validación en todas las sedes.</p>
                  <p>El acceso al evento es exclusivo para clientes con pase de acceso válido. Cada cliente podrá ingresar acompañado de un máximo de dos personas, quienes no podrán acceder al área de la dinámica y deberán permanecer en la zona designada para acompañantes.</p>

                  <h6 className="mt-3">Requisitos de acceso el día del evento</h6>
                  <p>Para ingresar al evento el cliente deberá presentar obligatoriamente:</p>
                  <ul>
                    <li>Pase de acceso físico o digital.</li>
                    <li>Documento de identidad físico o digital vigente que coincida con el nombre registrado en el pase.</li>
                  </ul>
                  <p>Si el cliente no presenta alguno de estos documentos, no podrá ingresar ni tomar parte en la actividad, perdiendo su derecho de vinculación sin compensación alguna.</p>

                  <h6 className="mt-3">Franjas horarias y puntualidad</h6>
                  <p>Los clientes serán citados en franjas horarias asignadas previamente por Hyundai Colombia según la ciudad y el volumen de clientes registrados. La franja horaria será informada a cada cliente a través del pase de acceso o por los canales oficiales de Hyundai Colombia.</p>
                  <p>El cliente deberá presentarse en su franja horaria asignada con un margen máximo de tolerancia de quince minutos. Transcurrido este tiempo sin que el cliente haya ingresado al área de registro, perderá su derecho de vinculación de forma definitiva sin posibilidad de reclamo ni compensación.</p>

                  <h6 className="mt-3">Descripción del elemento central de la actividad</h6>
                  <p>En cada estación se dispondrá un vehículo modelo TUCSON de la misma referencia en todas las ciudades, posicionado de forma fija y lateral respecto al cliente. La ventana del conductor estará completamente abierta en todas las estaciones y ciudades durante el desarrollo de la actividad.</p>
                  <p>La distancia oficial de disparo es de siete (7) metros exactos, medidos desde el punto de disparo hasta la parte exterior de la puerta del vehículo. Esta distancia estará identificada con una señal física fija en el piso de cada estación antes del inicio del evento, garantizando que sea idéntica en todas las ciudades. Ningún cliente podrá modificar esta distancia ni posicionarse en un punto diferente al demarcado.</p>
                  <p>Los balones utilizados serán suministrados exclusivamente por Hyundai Colombia, contarán con las mismas características técnicas y de peso (tipo felpa) en todas las estaciones y ciudades. No se permitirá el uso de ningún balón diferente al oficial.</p>

                  <h6 className="mt-3">Preparación y ejecución del disparo</h6>
                  <p>Una vez el cliente entregue su pase en la estación asignada, dispondrá de un tiempo máximo de 5 minutos para completar su preparación, el cual constara de:</p>
                  <ul>
                    <li>Un (1) primer intento de prueba, el cual solo es de practica no representa un disparo oficial.</li>
                    <li>Dos (2) intentos ejecutar su disparo oficial.</li>
                  </ul>
                  <p>El cliente podrá elegir libremente el pie con el que ejecuta el disparo. El disparo deberá ejecutarse desde el punto demarcado en el piso. Si el cliente patea desde un punto diferente, el disparo será declarado inválido por el personal autorizado en cada estación.</p>

                  <h6 className="mt-3">Criterios de validación del disparo</h6>
                  <p>El disparo oficial será declarado válido únicamente cuando el balón ingrese completamente a través de la ventana del vehículo. Para que el disparo sea válido deben cumplirse simultáneamente las siguientes condiciones:</p>
                  <ul>
                    <li>El balón debe cruzar completamente el plano de la ventana.</li>
                    <li>El balón debe permanecer dentro del habitáculo del vehículo tras el ingreso.</li>
                  </ul>

                  <h6 className="mt-3">Estructura de rondas y eliminación</h6>
                  <p>La actividad se desarrollará en formato de eliminación directa por rondas sucesivas:</p>
                  <ul>
                    <li><strong>ETAPA 1:</strong> En esta instancia únicamente avanzan a la etapa 2 los clientes que acierten.</li>
                    <li><strong>ETAPA 2:</strong> En cada ronda, todos los clientes activos ejecutan su disparo oficial. Quienes obtengan un disparo válido avanzan a la siguiente ronda. Quienes no lo obtengan quedan eliminados de forma definitiva.</li>
                  </ul>

                  <h6 className="mt-3">Criterios de desempate</h6>
                  <p>Si en una ronda todos los clientes activos obtienen un disparo inválido simultáneamente, se realizará una ronda adicional de desempate inmediata bajo las mismas condiciones. Los primeros clientes en anotar en esa ronda adicional serán quienes avancen.</p>
                  <p>Si en una ronda todos los clientes activos fallan simultáneamente, se aplicará el siguiente protocolo de desempate progresivo:</p>
                  <ul>
                    <li>Primera instancia: ronda adicional inmediata, esta vez solo con un (1) intento y con dos ventanas abiertas, desde 7 metros.</li>
                    <li>Si todos vuelven a fallar, la distancia se reducirá a 6 metros.</li>
                    <li>Si persiste el fallo general, la distancia se reducirá progresivamente hasta llegar a una distancia mínima de tres (3) metros.</li>
                  </ul>

                  <h6 className="mt-3">Lesión durante el evento, interrupciones, daños al vehículo y ganadores</h6>
                  <p>Si un cliente sufre una lesión, podrá designar un reemplazante de forma inmediata presente en el evento. De lo contrario quedará eliminado.</p>
                  <p>Si el evento es interrumpido por condiciones climáticas adversas o fuerza mayor, se suspenderá la actividad y se comunicará una nueva fecha a través de los canales oficiales.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 7 */}
              <Accordion.Item eventKey="6" className="mb-3" style={accordionStyle}>
                <Accordion.Header>7. DISTRIBUCIÓN DE ENTRADAS</Accordion.Header>
                <Accordion.Body>
                  <p>Hyundai Colombia entregará un total de dieciocho (18) entradas individuales distribuidas geográficamente así:</p>
                  <ul>
                    <li>Bogotá: 8 clientes</li>
                    <li>Medellín: 5 clientes</li>
                    <li>Cali: 3 clientes</li>
                    <li>Barranquilla: 2 clientes</li>
                  </ul>
                  <p>La distribución por ciudad es fija e invariable. En caso de que el número de clientes en una ciudad sea inferior al de entradas asignadas, Hyundai Colombia podrá asignar las entradas sobrantes al siguiente cliente elegible según su criterio u objetividad interna.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 8 */}
              <Accordion.Item eventKey="7" className="mb-3" style={accordionStyle}>
                <Accordion.Header>8. DETALLE DE LAS ENTRADAS</Accordion.Header>
                <Accordion.Body>
                  <p>El cliente que resulte beneficiario en el evento final recibirá:</p>
                  <ul>
                    <li>Una (1) entrada individual para un partido oficial de la Copa Mundial de la FIFA 2026™, sin costo adicional para el cliente.</li>
                  </ul>
                  <p>La entrada NO incluye:</p>
                  <ul>
                    <li>Transporte local o internacional.</li>
                    <li>Tiquetes aéreos.</li>
                    <li>Hospedaje.</li>
                    <li>Alimentación.</li>
                    <li>Seguros de viaje ni gastos consulares (visa, pasaporte u otros documentos de viaje).</li>
                    <li>Compensación monetaria de ningún tipo.</li>
                  </ul>
                  <p>El partido a visitar es asignado por la organización y no puede ser elegido por el cliente. Todos los gastos mencionados son responsabilidad exclusiva del cliente.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 9 */}
              <Accordion.Item eventKey="8" className="mb-3" style={accordionStyle}>
                <Accordion.Header>9. ENTREGA DE LAS ENTRADAS</Accordion.Header>
                <Accordion.Body>
                  <p>La entrega se efectuará el mismo día del evento, sábado 22 de mayo de 2026, en el lugar definido por Hyundai Colombia.</p>
                  <p>El cliente deberá firmar físicamente un documento de exoneración de responsabilidad. La entrada será entregada de forma digital mediante correo electrónico y/o WhatsApp. Si el cliente no se presenta o no firma el documento, Hyundai Colombia dispondrá libremente de la entrada sin compensación.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 10 */}
              <Accordion.Item eventKey="9" className="mb-3" style={accordionStyle}>
                <Accordion.Header>10. CONDUCTAS PROHIBIDAS Y DESCALIFICACIÓN</Accordion.Header>
                <Accordion.Body>
                  <p>Quedará descalificado de forma inmediata y definitiva cualquier cliente que incurra en alguna de las siguientes conductas:</p>
                  <ul>
                    <li>Suministro de datos falsos o suplantación de identidad.</li>
                    <li>Manipulación, alteración o intento de fraude en cualquier etapa de la actividad.</li>
                    <li>Uso indebido del pase de acceso por parte de personas no autorizadas.</li>
                    <li>Cualquier acto que atente contra la transparencia, la buena fe o la equidad de la actividad.</li>
                  </ul>
                  <p>La descalificación conlleva la pérdida inmediata del derecho a recibir la entrada y, en caso de haberla recibido, la obligación de restitución, sin perjuicio de las acciones legales que correspondan.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 11 */}
              <Accordion.Item eventKey="10" className="mb-3" style={accordionStyle}>
                <Accordion.Header>11. REVENTA DE ENTRADAS</Accordion.Header>
                <Accordion.Body>
                  <p>En caso de que el cliente proceda a la reventa de su entrada, Hyundai Colombia no asumirá ninguna responsabilidad por dicha conducta ni por las consecuencias que de ella se deriven, siendo el cliente el único responsable ante cualquier reclamación de terceros o autoridad competente.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 12 */}
              <Accordion.Item eventKey="11" className="mb-3" style={accordionStyle}>
                <Accordion.Header>12. FALLECIMIENTO O LIMITACIÓN GRAVE DEL CLIENTE</Accordion.Header>
                <Accordion.Body>
                  <p>En caso de fallecimiento o limitación física o médica grave debidamente certificada:</p>
                  <ul>
                    <li><strong>Antes del evento:</strong> El comprador podrá designar a otro participante elegible según las opciones establecidas con 48 hrs de antelación.</li>
                    <li><strong>Después de ganar y antes de la entrega:</strong> La entrada podrá ser transferida a un familiar en primer grado de consanguinidad previa comunicación y firma del documento de exoneración.</li>
                    <li><strong>Fallecimiento:</strong> Se deberá notificar a Hyundai en 48 hrs y presentar requisitos (registro de defunción, documento de identidad y parentesco) para que un integrante capacitado pueda sustituirlo conforme las políticas.</li>
                  </ul>
                  <p>Hyundai Colombia se reserva el derecho de validar la documentación antes de autorizar cualquier cambio.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 13 */}
              <Accordion.Item eventKey="12" className="mb-3" style={accordionStyle}>
                <Accordion.Header>13. TRANSFERENCIA Y PÉRDIDA DE ENTRADAS</Accordion.Header>
                <Accordion.Body>
                  <p>Las entradas son transferibles una vez entregadas, dado que no están asociadas individualmente en el evento. Hyundai Colombia no será responsable por el uso, reventa, pérdida o extravío.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 14 */}
              <Accordion.Item eventKey="13" className="mb-3" style={accordionStyle}>
                <Accordion.Header>14. OBLIGACIONES TRIBUTARIAS</Accordion.Header>
                <Accordion.Body>
                  <p>Los impuestos, contribuciones, tasas o gravámenes generados, incluyendo ganancia ocasional, serán asumidos única y exclusivamente por el cliente beneficiario. Hyundai no se hace responsable por ninguna obligación tributaria.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 15 */}
              <Accordion.Item eventKey="14" className="mb-3" style={accordionStyle}>
                <Accordion.Header>15. LIMITACIÓN DE RESPONSABILIDAD</Accordion.Header>
                <Accordion.Body>
                  <p>Hyundai Colombia, sus afiliadas y la red no serán responsables por:</p>
                  <ul>
                    <li>Trámites Migratorios y Visas (costos, demoras, negativas).</li>
                    <li>Inasistencia por Documentación o inadmisión fronteriza.</li>
                    <li>Cambios o reprogramaciones en el Evento por la FIFA.</li>
                    <li>Gastos de viaje, vuelos u hoteles.</li>
                    <li>Imprevistos de Salud o Accidentes.</li>
                    <li>Fallos en Plataformas Externas digitales.</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 16 */}
              <Accordion.Item eventKey="15" className="mb-3" style={accordionStyle}>
                <Accordion.Header>16. TRATAMIENTO DE DATOS PERSONALES</Accordion.Header>
                <Accordion.Body>
                  <p>Al participar autoriza de manera libre y expresa a Hyundai Colombia S.A.S. para recolectar, almacenar y tratar sus datos personales conforme a la Política de Tratamiento de Datos Personales disponible en <a href="https://www.hyundaicolombia.co/legales/politicas-privacidad-de-datos.pdf" target="_blank" rel="noreferrer">https://www.hyundaicolombia.co/legales/politicas-privacidad-de-datos.pdf</a>. Tiene derecho a consultar, rectificar y suprimir escribiendo a habeasdata.co@astara.com.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 17 */}
              <Accordion.Item eventKey="16" className="mb-3" style={accordionStyle}>
                <Accordion.Header>17. AUTORIZACIÓN DE USO DE IMAGEN</Accordion.Header>
                <Accordion.Body>
                  <p>El cliente autoriza expresamente el uso de su nombre, voz e imagen obtenidos en la actividad para fines publicitarios a nivel nacional e internacional sin compensación.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 18 */}
              <Accordion.Item eventKey="17" className="mb-3" style={accordionStyle}>
                <Accordion.Header>18. RECLAMACIONES</Accordion.Header>
                <Accordion.Body>
                  <p>Cualquier reclamo debe hacerse por escrito dentro de los 10 días, y las decisiones de Hyundai Colombia frente a dichos reclamos serán finales.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 19 */}
              <Accordion.Item eventKey="18" className="mb-3" style={accordionStyle}>
                <Accordion.Header>19. CANALES OFICIALES DE CONTACTO Y ATENCIÓN</Accordion.Header>
                <Accordion.Body>
                  <p>Para peticiones, quejas, reclamos, sugerencias o cualquier inquietud relacionada con esta actividad, los clientes podrán comunicarse a través de los siguientes canales:</p>
                  <ul>
                    <li>Correo electrónico: <strong>scliente.hyundai.co@astara.com</strong></li>
                    <li>WhatsApp / Chatbot: +57 1 519 00 55 – Hyundai, opción 3</li>
                    <li>Línea de servicio al cliente 01 8000 931 030</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 20 */}
              <Accordion.Item eventKey="19" className="mb-3" style={accordionStyle}>
                <Accordion.Header>20. MODIFICACIÓN Y SUSPENSIÓN</Accordion.Header>
                <Accordion.Body>
                  <p>Hyundai Colombia se reserva el derecho de modificar o cancelar justificando causas.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 21 */}
              <Accordion.Item eventKey="20" className="mb-3" style={accordionStyle}>
                <Accordion.Header>21. LEGISLACIÓN APLICABLE Y JURISDICCIÓN</Accordion.Header>
                <Accordion.Body>
                  <p>Estas condiciones se rigen bajo las leyes de la República de Colombia.</p>
                </Accordion.Body>
              </Accordion.Item>

              {/* ITEM 22 */}
              <Accordion.Item eventKey="21" className="mb-3" style={accordionStyle}>
                <Accordion.Header>22. ACEPTACIÓN EXPRESA</Accordion.Header>
                <Accordion.Body>
                  <p>La vinculación en esta actividad implica la aceptación plena, expresa e incondicional de todos los términos y condiciones aquí establecidos, sin reserva alguna. El cliente es responsable de conocerlos y cumplirlos en su totalidad.</p>
                </Accordion.Body>
              </Accordion.Item>

            </Accordion>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TerminosMundialComponent;
